import React from "react";
import { Button } from "react-bootstrap";
import "../styles/LocationPalms.css";
import { motion } from "framer-motion";
import mapImg from "../assets/palms-images/palms-location-1.webp";
import location from "../assets/palms-images/location.png";
import locationBg from "../assets/palms-images/palms-location-left.avif";

const LocationPalms = () => {
    return (
        <section className="location-palms-section" id="palms-location">
            <div className="container-fluid p-0">
                <div className="row m-0 w-100 h-100">

                    <div className="col-lg-7 d-flex text-start p-0">
                        <div className="location-pin-wrapper">
                            <img src={locationBg} alt="Location Pin" className="location-pin-img" />
                        </div>
                    </div>


                    {/* RIGHT SIDE - Map Only */}
                    <div className="col-lg-5 location-right p-0">
                        <img
                            src={mapImg}
                            alt="Palms Location Map"
                            className="location-map-bg"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LocationPalms;
